module.exports = __webpack_public_path__ + "img/austria-cancer-male.bbd79158.png";